export default "__VITE_ASSET__CpJImgeA__"